import React from 'react';
import './index.css';

function Article() {
  return (
    <div>
      <div className='impulsa-intro'>
        <h4>¡Impulsá tu negocio!</h4>
        <h5>TUTORIALES PARA EMPRENDEDORES</h5>
        <p>Presentamos los tutoriales diseñados para potenciar el desarrollo de tu negocio. Estos videos cubren una amplia gama de temas, desde educación financiera hasta comercio digital y e-commerce. Con ellos aprenderás sobre microcréditos, cómo evitar el sobreendeudamiento, cómo calcular los costos de tu emprendimiento, y mucho más!.</p>
      </div>
      <div className='columns impulsa'>
        <div className="col">
          <div className="videos">
            <div className="embed-container small">
              <div className='embed-responsive embed-responsive-16by9 with-curves'>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/OPVWh_o-j5Y?si=fAbOCKnXXeF2pyA-" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
            <div className="embed-container small">
              <h5>¿Cómo solicitar un microcrédito por BIP?</h5>
              <div className='embed-responsive embed-responsive-16by9 with-curves'>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/656pppczMgc" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className='col'>
          <div className='temas'>
            <h5>Temas:</h5>
            <ol start={2}>
              
              <li>¿QUÉ ES EL MICROCRÉDITO?</li>
              <li>¿CÓMO SABER SI ESTOY EN LA CENTRAL DE DEUDORES?</li>
              <li>MICROTIP ¿CUÁLES SON MIS DERECHOS FINANCIEROS?</li>
              <li>MICROTIP ¿CÓMO EVITAR EL SOBREENDEUDAMIENTO?</li>
              <li>¿CÓMO CALCULAR LOS COSTOS DE MI EMPRENDIMIENTO?</li>
              <li>COMERCIALIZACIÓN Y REDES SOCIALES</li>
              <li>COMERCIALIZACIÓN EN INSTAGRAM</li>
              <li>COMERCIALIZACIÓN EN WHATSAPP BUSINESS</li>
              <li>CÓMO SACAR BUENAS FOTOS DE TUS PRODUCTOS</li>
              <li>COMERCIO DIGITAL O E-COMMERCE</li>
            </ol>
          </div>
          <a href="https://www.provinciamicrocreditos.com.ar/comunidad/capacitaciones/tutoriales/" target='_blank' rel='noreferrer' className='btn-verde'>MÁS TIPS PARA HACER CRECER TU NEGOCIO</a>
        </div>
      </div>
    </div>
  );
}

export default Article;
